export default "/_next/static/images/myevent-accessory-bg-0c279dd9d459e6f5185a5165da7e94a1.png";